import React, { useEffect, useState } from 'react'
import './StatusPage.css'
import { fetch_task } from '../funcs';
const successLogo = '/icons/success.svg';
const errorLogo = '/icons/error.svg';

function StatusPage({ taskId, exit, successMessage, failureMessage, className="" }) {

    const [task, setTask] = useState();

    useEffect(()=>{fetch_task(taskId, setTask)}, [])

    return (
        <div className={`status-page ${className}`}>
                <img className='status-image' src={
                    task && task.status === "success" ? successLogo :
                    task && task.status === "failed" ? errorLogo :
                    ""
                }/>
                <label>
                    {
                        task && task.status === "success" ? successMessage :
                        task && task.status === "failed" ? failureMessage :
                        "Failed to get status"}
                </label>
            <button className='next' onClick={exit}>close</button>
        </div>
        )
    }

export default StatusPage